import { Button, Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { PortalShell } from '@/shared/ui/PortalShell'

export function NotFoundPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { search } = useLocation()

  return (
    <PortalShell>
      <Result
        status="404"
        title={t('notFound.title')}
        subTitle={t('notFound.text')}
        /*
          ⚠️ MEHMON UCHUN BU EKRAN BOSHI BERK KO'CHA EDI — bironta
          tugmasiz. U tizimni bilmaydi, hisobi yo'q va so'raydigan odami
          yo'q: yagona chorasi Wi-Fi'dan butunlay voz kechish edi.

          ⚠️ SO'ROV SATRI SAQLANADI. MikroTik `mac`/`nasid` ni aynan
          shu yerda beradi (`shared/lib/portalParams.ts`); ularsiz
          "boshidan boshlash" mehmonni sozlama xatosi ekraniga olib
          borardi. Saqlansa — u oqimning boshiga qaytadi; saqlanmasa
          ham `ConfigErrorPage` unga nima qilishni AYTADI, ya'ni ikkala
          holatda ham keyingi qadam bor.
        */
        extra={
          <Button type="primary" size="large" block onClick={() => navigate({ pathname: '/', search })}>
            {t('common.startOver')}
          </Button>
        }
      />
    </PortalShell>
  )
}
